"use client";

import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
interface BenefitItem {
  id: string;
  title: string;
  description: React.ReactNode;
}
const benefitItems: BenefitItem[] = [{
  id: "benefit-fixed-price",
  title: "Fast pris på entreprenaden",
  description: "En tydlig och specificerad kalkyl där rivning, underarbete, tätskikt, VVS, el och plattsättning ingår. Du vet exakt vad projektet kostar innan vi sätter igång."
}, {
  id: "benefit-rot-deduction",
  title: "ROT-avdraget hanteras direkt",
  description: "Vi administrerar kontakten med Skatteverket och drar av 30 % på arbetskostnaden direkt på din faktura, för ett smidigt och enkelt upplägg."
}, {
  id: "benefit-certification",
  title: "Auktorisation & giltigt våtrumsintyg",
  description: <>
        Alla VVS-arbeten utförs enligt Säker Vattens branschregler via vårt moderbolag{" "}
        <Link to="https://rs-ab.com/" newTab className="text-blue-600 underline hover:text-blue-800 transition-colors">
          RSAB Rörservice AB
        </Link>
        . Efter godkänd slutkontroll överlämnar vi ett komplett kvalitetsdokument som intygar att badrummet är fackmässigt byggt för ditt försäkringsbolag.
      </>
}];
export default function IncludedBenefitsQuote() {
  return <section id="includedbenefitsquote" data-nav="light" className="w-full bg-background text-foreground py-[60px]">
      <div className="max-w-[900px] mx-auto px-4 sm:px-6 md:px-8">
        {/* Header Block */}
        <div className="text-center max-w-2xl mx-auto mb-[35px]">
          <h2 className="text-2xl sm:text-3xl font-bold text-foreground tracking-tight mb-[15px]">
            Detta ingår alltid när du begär en badrumsoffert
          </h2>
          <p className="text-muted-foreground text-base leading-relaxed">
            Vi tror på fullständig transparens utan oväntade överraskningar. När du
            anlitar Proffsbadrum får du ett tryggt ramverk från kalkyl till
            färdigställande:
          </p>
        </div>

        {/* Benefits List */}
        <div className="space-y-6 sm:space-y-7 mb-10">
          {benefitItems.map((item, index) => <div key={item.id} data-index={index} className="flex items-start gap-4 sm:gap-5 p-4 sm:p-5 rounded-lg border border-border/60 bg-card/60 transition-colors">
              <div className="shrink-0 mt-0.5 size-7 rounded-full bg-primary/10 flex items-center justify-center text-primary">
                <Check className="size-4 stroke-[2.5]" aria-hidden="true" />
              </div>
              <div className="space-y-1">
                <h3 className="text-base sm:text-lg font-bold text-foreground">
                  {item.title}
                </h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>

        {/* Bottom Navigation Link */}
        <div className="text-center">
          <p className="text-muted-foreground text-sm sm:text-base mb-1">
            Vill du veta mer om de material och inredningar vi arbetar med?
          </p>
          <Link to="/BrandsPage" className="inline-flex items-center text-sm font-medium text-primary hover:underline underline-offset-4 transition-colors">
            Se våra utvalda varumärken →
          </Link>
        </div>
      </div>
    </section>;
}